import DropDTextMultiple from "./InputComponents/DropDTextMultipleComponent";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import CardHeader from "./Utils/CardHeaderComponent";
import React, { useState, useEffect } from "react";
import ConfirmationModal from "./Utils/ConfirmationModal";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";
interface OutputProps {
    errors: string[];
    dropdownValues: {
        tab: string;
        inputName: string;
        listValue: string[];
    }[];
    isCBE: boolean;
    tAndP:
    {
        table: string;
        property: string;
        tooltip: string;
        placeholder: string;
        id: string;
    }[];
    data: {
        // set0
        typeOfOutput: string;
        typeOfOutputText: string;
        typeOfOutputConfidential: boolean;

        // set1 CBE
        natureOfNoveltyBBI: string;
        natureOfNoveltyBBIText: string;
        natureOfNoveltyBBIConfidential: boolean;
        natureOfNoveltyCBE: string;
        natureOfNoveltyCBEText: string;
        natureOfNoveltyCBEConfidential: boolean;

        // set2
        typeOfBiobasedOutput: string;
        typeOfBiobasedOutputText: string;
        typeOfBiobasedOutputConfidential: boolean;
        // set3
        finalApplications: string[];
        finalApplicationText: string;
        finalApplicationsConfidential: boolean;
        // set 4 bbi
        compositionOfFeedstocks: string;
        compositionOfFeedstocksText: string;
        compositionOfFeedstocksConfidential: boolean;
        // set 5 bbi
        environmentalPerformanceOutput: string[];
        environmentalPerformanceOutputText: string;
        environmentalPerformanceOutputConfidential: boolean;
        // set 6 bbi
        economicPerformanceOutput: string[];
        economicPerformanceOutputText: string;
        economicPerformanceOutputConfidential: boolean;
        // set 7 bbi
        productPerformanceOutput: string[];
        productPerformanceOutputText: string;
        productPerformanceOutputConfidential: boolean;
        // set 4 cbe
        isProductImprovedLifeCycleEnvironmentalPerformance: string;
        isProductImprovedLifeCycleEnvironmentalPerformanceText: string;
        isProductImprovedLifeCycleEnvironmentalPerformanceConfidential: boolean;
        // set 5 cbe
        isProductCircular: string;
        productCircular: string[];
        isProductCircularText: string;
        isProductCircularConfidential: boolean;
    };

    handleDeleteOutput: () => void;
    handleOnChangeOutput: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    status: number;

    customLabelValues: {
        table: string;
        property: string;
        value: string;
        id: string;
    }[];
    handleUpdateEditableTitle: (id: string, value: string) => void;
}

function Output({
    data,
    handleDeleteOutput,
    handleOnChangeOutput,
    isCBE,
    status,
    dropdownValues,
    errors,
    customLabelValues,
    handleUpdateEditableTitle,
    tAndP
}: OutputProps) {
    const [isHidden, setIsHidden] = useState(true);
    const toggleVisibility = () => {
        setIsHidden((prevState) => !prevState);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleDeleteClick = () => {
        setIsModalOpen(true);
    };
    const confirmDelete = () => {
        setIsModalOpen(false);
        handleDeleteOutput();
    };
    const cancelDelete = () => {
        setIsModalOpen(false);
    };

    // Helper function to get the conditional label for natureOfNoveltyCBEText
    const getNatureOfNoveltyCBETextLabel = () => {
        if (data.natureOfNoveltyCBE?.toLowerCase().includes("the output is an innovative bio-based dedicated output, with novel or significantly improved properties vs relevant alternatives")) {
            return "Please describe the novel or significantly improved properties with reference to bio- or fossil-based benchmarks currently used for the same or similar application(s).";
        } else if (data.natureOfNoveltyCBE?.toLowerCase().includes("the output is a drop-in output meeting applications requirements")) {
            return "Please desribe how the output meets application requirements with reference to bio- or fossil-based benchmarks in the same or similar applications.";
        }
        return "Please describe the nature of novelty";
    };

    return (
        <>
            <div className="feedstock-container">
                <CardHeader
                    isHidden={isHidden}
                    toggleVisibility={toggleVisibility}
                    cardName="Output"
                    handleDelete={status == 1 ? handleDeleteClick : null}
                    notValid={errors.length > 0}
                />

                <div className={isHidden ? "hidden-content" : "visible-content"}>
                    {/* SET 0 */}
                    <div className="error-container">
                        {errors.map((error, index) => (
                            <div
                                className="error-text"
                                key={index}
                                style={{ marginBottom: "10px" }}
                            >
                                {error}
                            </div>
                        ))}
                    </div>
                    <div className="questions-wrapper">
                    {isCBE ? null : <div className="question-text">BBI JU KPI 4/5/6</div>}
                    <div className="row">
                        <Tooltip content={tAndP.find(item => item.property == "Type of output")?.tooltip}>
                            <div className="col-md-6 col-sm-12">
                                <DropdownStringMandatory
                                    listInputs={
                                        dropdownValues.filter(
                                            (item) => item.inputName == "typeOfOutput"
                                        )[0].listValue
                                    }
                                    label={"Type of output"}
                                    inputName={"typeOfOutput"}
                                    value={data.typeOfOutput}
                                    handleOnChange={handleOnChangeOutput}
                                    invalidValues={["-", ""]}

                                />
                            </div>
                        </Tooltip>
                        <div className="col-md-6 col-sm-12">
                            <div
                                className={
                                    data.typeOfOutput == "-" ||
                                        data.typeOfOutput == "" ||
                                        data.typeOfOutput == "N/A"
                                        ? "hidden-content"
                                        : "visible-content"
                                }
                            >
                                <TextConfidential
                                    label={"Describe the output"}
                                    textValid={data.typeOfOutputText.length > 4}
                                    textValue={data.typeOfOutputText}
                                    textName={"typeOfOutputText"}
                                    onChange={handleOnChangeOutput}
                                    display={data.typeOfOutput == "-"}
                                    isConfidential={data.typeOfOutputConfidential}
                                    confidentialInputName={"typeOfOutputConfidential"}

                                    editableTitle={<EditableTitle
                                        customLabelValue={customLabelValues.find(item => item.property == "typeOfOutputText")}
                                        handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className={
                            data.typeOfOutput == "" ||
                                data.typeOfOutput == "N/A" ||
                                data.typeOfOutput == "-"
                                ? "hidden-content"
                                : "visible-content"
                        }
                    >
                        {/* SET 1 */}
                        {!isCBE ? (
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <DropdownStringMandatory
                                        listInputs={
                                            dropdownValues.filter(
                                                (item) => item.inputName == "natureOfNoveltyBBI"
                                            )[0].listValue
                                        }
                                        label={"Nature of novelty"}
                                        inputName={"natureOfNoveltyBBI"}
                                        value={data.natureOfNoveltyBBI}
                                        handleOnChange={handleOnChangeOutput}
                                        invalidValues={["-", ""]}
                                        editableTitle={<EditableTitle
                                            customLabelValue={customLabelValues.find(item => item.property == "natureOfNoveltyBBI")}
                                            handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <TextConfidential
                                        label={"Please explain the novelty"}
                                        textValid={data.natureOfNoveltyBBIText.length > 4}
                                        textValue={data.natureOfNoveltyBBIText}
                                        textName={"natureOfNoveltyBBIText"}
                                        onChange={handleOnChangeOutput}
                                        display={
                                            data.natureOfNoveltyBBI == "" ||
                                            data.natureOfNoveltyBBI == "-" ||
                                            data.natureOfNoveltyBBI == "N/A"
                                        }
                                        isConfidential={data.natureOfNoveltyBBIConfidential}
                                        confidentialInputName={"natureOfNoveltyBBIConfidential"}
                                        editableTitle={<EditableTitle
                                            customLabelValue={customLabelValues.find(item => item.property == "natureOfNoveltyBBIText")}
                                            handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                    />
                                </div>
                            </div>
                        ) : null}
                        {/* SET 1 CBE */}
                        {isCBE ? (
                            <>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 6.1/6.2")?.tooltip}>
                                            <div className="question-text margin-top-50">
                                                CBE JU KPI 6.1/6.2  🛈
                                                <br />

                                                <EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "natureOfNoveltyCBE")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                            </div>
                                        </Tooltip>
                                        <DropdownStringMandatory
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "natureOfNoveltyCBE"
                                                )[0].listValue
                                            }
                                            label={""}
                                            inputName={"natureOfNoveltyCBE"}
                                            value={data.natureOfNoveltyCBE}
                                            handleOnChange={handleOnChangeOutput}
                                            invalidValues={["-", ""]}
                                        />
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div
                                            className={
                                                data.natureOfNoveltyCBE == "" ||
                                                    data.natureOfNoveltyCBE == "-" ||
                                                    data.natureOfNoveltyCBE == "N/A"
                                                    ? "hidden-content"
                                                    : "visible-content margin-top-20"
                                            }
                                        >
                                            <TextConfidential
                                                label={getNatureOfNoveltyCBETextLabel()}
                                                placeholder={""}
                                                textValid={data.natureOfNoveltyCBEText.length > 4}
                                                textValue={data.natureOfNoveltyCBEText}
                                                textName={"natureOfNoveltyCBEText"}
                                                onChange={handleOnChangeOutput}
                                                display={false}
                                                isConfidential={data.natureOfNoveltyCBEConfidential}
                                                confidentialInputName={"natureOfNoveltyCBEConfidential"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : null}
                        {/* SET 2 */}
                        <div className="row">
                            <div className="question-text margin-top-50">
                                {<EditableTitle
                                    customLabelValue={customLabelValues.find(item => item.property == "typeOfOutput")}
                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}</div>
                            <div className="col-md-6 col-sm-12">
                                <DropdownStringMandatory
                                    listInputs={
                                        dropdownValues.filter(
                                            (item) => item.inputName == "typeOfBiobasedOutput"
                                        )[0].listValue
                                    }
                                    label={" "}
                                    inputName={"typeOfBiobasedOutput"}
                                    value={data.typeOfBiobasedOutput}
                                    handleOnChange={handleOnChangeOutput}
                                    invalidValues={["-", ""]}
                                />
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <TextConfidential
                                    label={"Describe the output"}
                                    textValid={
                                        data.typeOfBiobasedOutputText.length > 4 ||
                                        data.typeOfBiobasedOutput != "Other"
                                    }
                                    textValue={data.typeOfBiobasedOutputText}
                                    textName={"typeOfBiobasedOutputText"}
                                    onChange={handleOnChangeOutput}
                                    isConfidential={data.typeOfBiobasedOutputConfidential}
                                    confidentialInputName={"typeOfBiobasedOutputConfidential"}
                                    display={
                                        data.typeOfBiobasedOutput == "" ||
                                        data.typeOfBiobasedOutput == "-" ||
                                        data.typeOfBiobasedOutput == "N/A"
                                    }
                                    editableTitle={<EditableTitle
                                        customLabelValue={customLabelValues.find(item => item.property == "typeOfBiobasedOutputText")}
                                        handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                />
                            </div>
                        </div>
                        {/* SET 3 */}

                        <div
                            className={
                                data.typeOfBiobasedOutput == "-" ||
                                    data.typeOfBiobasedOutput == "" ||
                                    data.typeOfBiobasedOutput == "N/A"
                                    ? "hidden-content"
                                    : "visible-content"
                            }
                        >
                            <div className="row">
                                <div className="question-text margin-top-50">
                                    <EditableTitle
                                        customLabelValue={customLabelValues.find(item => item.property == "finalApplications")}
                                        handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <DropDTextMultiple
                                        listInputs={
                                            dropdownValues.filter(
                                                (item) => item.inputName == "finalApplications"
                                            )[0].listValue
                                        }
                                        label={""}
                                        inputName={"finalApplications"}
                                        value={data.finalApplications}
                                        handleOnChange={handleOnChangeOutput}
                                        isValid={data.finalApplications.length > 0}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <TextConfidential
                                        label={"Describe the final applications"}
                                        textValid={
                                            data.finalApplicationText.length > 4 ||
                                            !data.finalApplications.includes("Other")
                                        }
                                        textValue={data.finalApplicationText}
                                        textName={"finalApplicationText"}
                                        onChange={handleOnChangeOutput}
                                        display={
                                            data.finalApplications.length == 0 ||
                                            (data.finalApplications.includes("N/A") &&
                                                !data.finalApplications.includes("Other"))
                                        }
                                        isConfidential={data.finalApplicationsConfidential}
                                        confidentialInputName={"finalApplicationsConfidential"}

                                        editableTitle={<EditableTitle
                                            customLabelValue={customLabelValues.find(item => item.property == "finalApplicationText")}
                                            handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                    />
                                </div>
                            </div>
                        </div>
                        {isCBE ? null : (
                            <>
                                {/* SET 4 */}
                                {!isCBE ? (
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <DropdownStringMandatory
                                                listInputs={
                                                    dropdownValues.filter(
                                                        (item) =>
                                                            item.inputName == "compositionOfFeedstocks"
                                                    )[0].listValue
                                                }
                                                label={"Composition of the feedstock used"}
                                                inputName={"compositionOfFeedstocks"}
                                                value={data.compositionOfFeedstocks}
                                                handleOnChange={handleOnChangeOutput}
                                                invalidValues={["", "-"]}
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "compositionOfFeedstocks")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <TextConfidential
                                                label={"please describe"}
                                                textValid={
                                                    data.compositionOfFeedstocksText.length > 4 ||
                                                    data.compositionOfFeedstocks != "Other"
                                                }
                                                textValue={data.compositionOfFeedstocksText}
                                                textName={"compositionOfFeedstocksText"}
                                                onChange={handleOnChangeOutput}
                                                display={
                                                    data.compositionOfFeedstocks == "-" ||
                                                    data.compositionOfFeedstocks == "" ||
                                                    data.compositionOfFeedstocks == "N/A"
                                                }
                                                isConfidential={
                                                    data.compositionOfFeedstocksConfidential
                                                }
                                                confidentialInputName={
                                                    "compositionOfFeedstocksConfidential"
                                                }
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "compositionOfFeedstocksText")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                    </div>
                                ) : null}

                                {/* SET 5 */}
                                {!isCBE ? (
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <DropDTextMultiple
                                                listInputs={
                                                    dropdownValues.filter(
                                                        (item) =>
                                                            item.inputName == "environmentalPerformanceOutput"
                                                    )[0].listValue
                                                }
                                                label={
                                                    "Positive environmental performance of the output"
                                                }
                                                inputName={"environmentalPerformanceOutput"}
                                                value={data.environmentalPerformanceOutput}
                                                handleOnChange={handleOnChangeOutput}
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "environmentalPerformanceOutput")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <TextConfidential
                                                label={"please describe"}
                                                textValid={
                                                    data.environmentalPerformanceOutputText.length > 4 ||
                                                    !data.environmentalPerformanceOutput.includes(
                                                        "Others"
                                                    )
                                                }
                                                textValue={data.environmentalPerformanceOutputText}
                                                textName={"environmentalPerformanceOutputText"}
                                                onChange={handleOnChangeOutput}
                                                isConfidential={
                                                    data.environmentalPerformanceOutputConfidential
                                                }
                                                confidentialInputName={
                                                    "environmentalPerformanceOutputConfidential"
                                                }
                                                display={
                                                    data.environmentalPerformanceOutput.length == 0 ||
                                                    (data.environmentalPerformanceOutput.includes(
                                                        "N/A"
                                                    ) &&
                                                        !data.environmentalPerformanceOutput.includes(
                                                            "Others"
                                                        ))
                                                }
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "environmentalPerformanceOutputText")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                                {/* SET 6 */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) =>
                                                        item.inputName == "economicPerformanceOutput"
                                                )[0].listValue
                                            }
                                            label={"Positive economic performance of the output"}
                                            inputName={"economicPerformanceOutput"}
                                            value={data.economicPerformanceOutput}
                                            handleOnChange={handleOnChangeOutput}
                                            editableTitle={<EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "economicPerformanceOutput")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <TextConfidential
                                            label={"please describe"}
                                            textValid={
                                                data.economicPerformanceOutputText.length > 4 ||
                                                !data.economicPerformanceOutput.includes("Others")
                                            }
                                            textValue={data.economicPerformanceOutputText}
                                            textName={"economicPerformanceOutputText"}
                                            onChange={handleOnChangeOutput}
                                            isConfidential={
                                                data.economicPerformanceOutputConfidential
                                            }
                                            confidentialInputName={
                                                "economicPerformanceOutputConfidential"
                                            }
                                            display={
                                                data.economicPerformanceOutput.length == 0 ||
                                                (data.economicPerformanceOutput.includes("N/A") &&
                                                    !data.economicPerformanceOutput.includes("Others"))
                                            }
                                            editableTitle={<EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "economicPerformanceOutputText")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                        />
                                    </div>
                                </div>
                                {/* SET 7 */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "productPerformanceOutput"
                                                )[0].listValue
                                            }
                                            label={
                                                "Product performance (improved/ new functionalities) of the output"
                                            }
                                            inputName={"productPerformanceOutput"}
                                            value={data.productPerformanceOutput}
                                            handleOnChange={handleOnChangeOutput}
                                            editableTitle={<EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "productPerformanceOutput")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <TextConfidential
                                            label={"please describe"}
                                            textValid={
                                                data.productPerformanceOutputText.length > 4 ||
                                                !data.productPerformanceOutput.includes("Others")
                                            }
                                            textValue={data.productPerformanceOutputText}
                                            textName={"productPerformanceOutputText"}
                                            onChange={handleOnChangeOutput}
                                            isConfidential={data.productPerformanceOutputConfidential}
                                            confidentialInputName={
                                                "productPerformanceOutputConfidential"
                                            }
                                            display={
                                                data.productPerformanceOutput.length == 0 ||
                                                (data.productPerformanceOutput.includes("N/A") &&
                                                    !data.productPerformanceOutput.includes("Others"))
                                            }
                                            editableTitle={<EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "productPerformanceOutputText")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {isCBE ? (
                            <>
                                {/* SET 4 CBE */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 4.5")?.tooltip}>
                                            <div className="question-text margin-top-50">
                                                CBE JU KPI 4.5  🛈 <br />

                                                <EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "isProductImprovedLifeCycleEnvironmentalPerformance")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                            </div></Tooltip>
                                        <DropdownStringMandatory
                                            listInputs={["-", "Yes", "No", "N/A"]}
                                            label={""}
                                            inputName={
                                                "isProductImprovedLifeCycleEnvironmentalPerformance"
                                            }
                                            value={
                                                data.isProductImprovedLifeCycleEnvironmentalPerformance
                                            }
                                            handleOnChange={handleOnChangeOutput}
                                            invalidValues={["", "-"]}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextConfidential
                                            label={"Please specify the benchmark(s) and quantify the improvements providing details on how this is calculated"}
                                            textValid={
                                                data
                                                    .isProductImprovedLifeCycleEnvironmentalPerformanceText
                                                    .length > 4
                                            }
                                            textValue={
                                                data.isProductImprovedLifeCycleEnvironmentalPerformanceText
                                            }
                                            textName={
                                                "isProductImprovedLifeCycleEnvironmentalPerformanceText"
                                            }
                                            onChange={handleOnChangeOutput}
                                            isConfidential={
                                                data.isProductImprovedLifeCycleEnvironmentalPerformanceConfidential
                                            }
                                            confidentialInputName={
                                                "isProductImprovedLifeCycleEnvironmentalPerformanceConfidential"
                                            }
                                            display={
                                                data.isProductImprovedLifeCycleEnvironmentalPerformance !=
                                                "Yes"
                                            }
                                            placeholder={tAndP.find(item => item.property == "CBE JU KPI 4.5")?.placeholder}
                                        />
                                    </div>
                                </div>
                                {/* SET 5 CBE */}

                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 5.1")?.tooltip} wide={true}>
                                            <div className="question-text margin-top-50">
                                                CBE JU KPI 5.1  🛈 <br />

                                                <EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "isProductCircular")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle}
                                                />
                                            </div>
                                        </Tooltip>
                                        <DropdownStringMandatory
                                            listInputs={["-", "Yes", "No", "N/A"]}
                                            label={""}
                                            inputName={"isProductCircular"}
                                            value={data.isProductCircular}
                                            handleOnChange={handleOnChangeOutput}
                                            invalidValues={["", "-"]}
                                        />
                                    </div>

                                    <div
                                        className={
                                            data.isProductCircular == "Yes"
                                                ? "visible-content"
                                                : "hidden-content"
                                        }
                                    >
                                        <div className="col-md-12 col-sm-12 padding">
                                            <DropDTextMultiple
                                                listInputs={
                                                    dropdownValues.filter(
                                                        (item) => item.inputName == "productCircular"
                                                    )[0].listValue
                                                }
                                                label={"Please select one or more characteristic below"}
                                                inputName={"productCircular"}
                                                value={data.productCircular}
                                                handleOnChange={handleOnChangeOutput}
                                                isValid={data.productCircular.length > 0}
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "productCircular")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                            />
                                        </div>
                                        <div className="col-md-12 col-sm-12 padding">
                                            <TextConfidential
                                                label={"please describe"}
                                                textValid={true}
                                                textValue={data.isProductCircularText}
                                                textName={"isProductCircularText"}
                                                onChange={handleOnChangeOutput}
                                                display={
                                                    data.productCircular.length < 1 ||
                                                    data.productCircular.includes("0")
                                                }
                                                isConfidential={data.isProductCircularConfidential}
                                                confidentialInputName="isProductCircularConfidential"
                                                editableTitle={<EditableTitle
                                                    customLabelValue={customLabelValues.find(item => item.property == "isProductCircularText")}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle} />}
                                                placeholder={tAndP.find(item => item.property == "CBE JU KPI 5.1")?.placeholder}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                    </div>
                </div>
            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={cancelDelete}
                onConfirm={confirmDelete}
                title="
        Confirm deletion"
                message="Are you sure you want to delete this component ?"
            />
        </>
    );
}

export default Output;